import { SharedDocument } from 'types/Document';
import CreatorIcon from 'views/App/Share/ShareExplorer/FolderContentExplorer/CreatorIcon';
import {Video} from 'components';

export type VideoPreviewProps = {
  document: SharedDocument;
};

export const VideoPreview = ({ document } : VideoPreviewProps) : JSX.Element => (
  <div data-testid='video-preview'>
    <Video width='150' src={document.blob.s3URL} labelId='locale' />
    <CreatorIcon document={document} />
  </div>
);

export default VideoPreview;